export default __webpack_public_path__ + "static/media/btcb.99bbd687.svg";